import {
    FETCH_BOOKING,
    FETCH_BOOKINGS,
    FETCH_BOOKINGS_ACCUMULATED,
    FETCH_BOOKINGS_FAILURE,
    FETCH_BOOKINGS_SUCCESS,
    FETCH_BOOKING_ACCUMULATED,
    FETCH_BOOKING_FAILURE,
    FETCH_BOOKING_SUCCESS,
} from 'store/actions/types';
import utils from 'helpers/utils';
import { isValidPhoneNumber, parsePhoneNumberWithError } from 'libphonenumber-js';

export const fetchBookings = (payload) => {
    payload = payload || {};

    let params = {
        size: payload.size ? payload.size : 24,
        sort_by: payload.field ? payload.field : 'created_at',
        sort_direction: payload.order ? payload.order.toLowerCase() : 'desc',
    };

    if (payload.company_name) {
        params.company_name = payload.company_name;
    }

    if (!payload.offset && payload.page) {
        params.offset = (payload.page - 1) * params.size;
    }

    if (!utils.isEmpty(payload.filter)) {
        const filters = utils.buildFilterObject(payload.filter);

        params = Object.assign({}, params, filters);
    }

    /*
     * Phone number needs to be sent as 2 distinct values (country & phone number)
     * in order for the backend to reconsile them and always use the same phone
     * number system.
     *
     * This might need to be made more generic in case we get more endpoints which
     * are filterable by phone.
     */
    if (!utils.isEmpty(params.phone) && isValidPhoneNumber(params.phone)) {
        const phonenumber = parsePhoneNumberWithError(params.phone, {
            defaultCountry: 'NL',
        });

        params.phone_country = phonenumber.country;
        params.phone = phonenumber.nationalNumber;
    }

    return {
        type: FETCH_BOOKINGS,
        payload: params,
    };
};

export const fetchBookingsFailure = (error) => {
    return {
        type: FETCH_BOOKINGS_FAILURE,
        error: error,
    };
};

export const fetchBookingsSuccess = (response) => {
    return {
        type: FETCH_BOOKINGS_SUCCESS,
        response: response,
    };
};

export const fetchBooking = (payload) => {
    return {
        type: FETCH_BOOKING,
        payload: payload,
    };
};

export const fetchBookingFailure = (error) => {
    return {
        type: FETCH_BOOKING_FAILURE,
        error: error,
    };
};

export const fetchBookingSuccess = (response) => {
    return {
        type: FETCH_BOOKING_SUCCESS,
        response: response,
    };
};

export const fetchBookingAccumulated = (payload) => {
    return {
        type: FETCH_BOOKING_ACCUMULATED,
        payload: {
            id: payload.id,
            resource: 'bookings',
            type: FETCH_BOOKINGS_ACCUMULATED,
        },
    };
};

export const updateListParams = (payload) => {
    return {
        type: payload.type,
        payload: payload.payload,
    };
};



// WEBPACK FOOTER //
// ./src/store/actions/bookings/fetchBookings.js